var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_notification",
    "data-name": "icon - notification",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.37,
    height: 36.727,
    viewBox: "0 0 36.37 36.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_-_notification-2",
    "data-name": "icon - notification",
    transform: "translate(-1733.63 -68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bottom",
    d: "M1744,101.189h8s0,4.264-4.021,4.264S1744,101.189,1744,101.189Z",
    transform: "translate(0.925 -1)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "middle",
    d: "M1739.685,79.588s.483-7.66,9.391-7.66,9.125,7.66,9.125,7.66,1.014,8.5,5.069,14.285-10.1,5.886-10.1,5.886h-9.559s-13.361.34-9.161-5.886S1739.685,79.588,1739.685,79.588Z",
    transform: "translate(0)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "top",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1744.925 68)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "notification_circle",
    "data-name": "notification circle",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(1758 92.727)",
    fill: "#f33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon-notification.7d482d78036083d41d6c2b1d2d9058ce.svg";
export { ForwardRef as ReactComponent };